var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_110",
    "data-name": "Rectangle 110",
    width: 24,
    height: 24,
    fill: "#5e5e5e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tweeter"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116",
    "data-name": "Group 116",
    transform: "translate(2 4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115",
    "data-name": "Group 115"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_113",
    "data-name": "Group 113"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M183.164,284.091a.159.159,0,0,0-.067.132,10.938,10.938,0,0,1-.08,1.838,12.177,12.177,0,0,1-1.063,3.69,11.8,11.8,0,0,1-2.244,3.269,11.065,11.065,0,0,1-5.689,3.174,12.151,12.151,0,0,1-2.31.272,11.688,11.688,0,0,1-6.635-1.779l-.1-.065a8.348,8.348,0,0,0,4.147-.569A8.183,8.183,0,0,0,171.1,292.9a4.158,4.158,0,0,1-3.859-2.871,4.122,4.122,0,0,0,1.779-.059.149.149,0,0,0,.059-.022,4.17,4.17,0,0,1-2.694-1.9,4.039,4.039,0,0,1-.6-2.207,4.1,4.1,0,0,0,1.844.51,4.2,4.2,0,0,1-1.7-2.518,4.143,4.143,0,0,1,.442-3,11.857,11.857,0,0,0,8.547,4.332c-.023-.164-.046-.311-.067-.457a4.069,4.069,0,0,1,.605-2.708,3.972,3.972,0,0,1,2.811-1.868,4.037,4.037,0,0,1,3.632,1.151.209.209,0,0,0,.222.067,8.318,8.318,0,0,0,2.4-.929.467.467,0,0,1,.06-.023c0-.007.006-.007.021-.007a4.216,4.216,0,0,1-1.771,2.257,8.171,8.171,0,0,0,2.31-.619c0,.008.007.008.013.015-.162.207-.31.42-.478.627A7.939,7.939,0,0,1,183.164,284.091Z",
    transform: "translate(-164.98 -280.065)",
    fill: "#5e5e5e"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterGray);
export default __webpack_public_path__ + "static/media/twitterGray.099b23855c4eb6ec675c80375ac574a6.svg";
export { ForwardRef as ReactComponent };